// extracted by mini-css-extract-plugin
export default {"content":"gpBE56Y8J971rGOdaq91","ctaBoxContent":"cSWeB0qfHJs3Zk98T_Fu"};